import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import CartDrawer from './components/CartDrawer';
import ImageViewer from './components/ImageViewer';
import ScrollToTop from './components/ScrollToTop';
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { PhoneFloat } from "./components/PhoneFloat";
import { Home } from "./pages/Home";
import { LocationPage } from "./pages/LocationPage";
import { VRVPage } from "./pages/VRVPage";
import { Toaster } from "./components/ui/sonner";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { CookieNotice } from "./components/CookieNotice";
import { ClearancePage } from "./pages/ClearancePage";
import ClearanceDetail from "./pages/ClearanceDetail";
import DaikinPage from './pages/DaikinPage';
import ACCalculator from './pages/ACCalculator';
import Consultation from './pages/Consultation';
import Architects from './pages/Architects';
import DaikinPrices from './pages/DaikinPrices';
import Checkout from './pages/Checkout';
import OrderConfirmed from './pages/OrderConfirmed';
import RequestUnit from './pages/RequestUnit';
import Resume from './pages/Resume';
import StockAdmin from './pages/StockAdmin';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import Canonical from './components/Canonical';
import ProductDetail from './pages/ProductDetail';
import CollectionPage from './pages/CollectionPage';
import { CATALOGUE } from './data/catalogue';
import CompareAC from './pages/CompareAC';
import { comparableSizes, sizeSlug } from './data/compare';
import { COLLECTIONS } from './data/collections';
import Cart from './pages/Cart';
import Blog from './pages/Blog';
import InverterGuide from './pages/InverterGuide';
import UnitsGuide from './pages/UnitsGuide';
import DifferenceGuide from './pages/DifferenceGuide';
import StarsGuide from './pages/StarsGuide';
import TempGuide from './pages/TempGuide';
import InstallGuide from './pages/InstallGuide';
import VRVGuide from './pages/VRVGuide';
import SizeGuide from './pages/SizeGuide';
import HeatGuide from './pages/HeatGuide';
import VrvHomeGuide from './pages/VrvHomeGuide';
import { RefundPolicy, TermsConditions, DeliveryPolicy } from './pages/Policies';

// The consultation page moved to /hvac-consultant before launch; keep any old
// link working, with its ?service= and other settings.
function OldConsultUrl() {
  const { search } = useLocation();
  return <Navigate to={`/hvac-consultant${search}`} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <CartDrawer />
        <ImageViewer />
        <ScrollToTop />
        <Canonical />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/daikin-vrv-systems" element={<VRVPage />} />
          {COLLECTIONS.map((c) => (
          <Route key={c.slug} path={`/${c.slug}`} element={<CollectionPage />} />
          ))}
          {CATALOGUE.map((m) => (
            <Route key={m.id} path={`/${m.slug}`} element={<ProductDetail />} />
          ))}
          {COLLECTIONS.map((c) => (
          <Route key={c.slug} path={`/${c.slug}`} element={<CollectionPage />} />
          ))}
          {CATALOGUE.map((m) => (
          <Route key={m.id} path={`/${m.slug}`} element={<ProductDetail />} />
          ))}
          <Route path="/compare-ac" element={<CompareAC />} />
          {comparableSizes(CATALOGUE).map((t) => (
            <Route key={t} path={`/${sizeSlug(t)}`} element={<CompareAC />} />
          ))}
          <Route path="/compare/:pair" element={<CompareAC />} />
        <Route path="/:slug" element={<LocationPage />} />
          <Route path="/clearance-ac-sale" element={<ClearancePage />} />
          <Route path="/clearance-ac-sale/:slug" element={<ClearanceDetail />} />
          <Route path="/daikin-ac/:slug" element={<ProductDetail />} />
          <Route path="/daikin-acs" element={<Navigate to="/daikin-ac-price-list-delhi" replace />} />
          <Route path="/ac-calculator" element={<ACCalculator />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/inverter-vs-non-inverter-ac" element={<InverterGuide />} />
          <Route path="/blog/ac-power-consumption-units-per-hour" element={<UnitsGuide />} />
          <Route path="/blog/difference-between-inverter-and-non-inverter-ac" element={<DifferenceGuide />} />
          <Route path="/blog/3-star-vs-5-star-ac" element={<StarsGuide />} />
          <Route path="/blog/ideal-ac-temperature" element={<TempGuide />} />
          <Route path="/blog/ac-installation-cost" element={<InstallGuide />} />
          <Route path="/blog/vrv-vs-split-ac" element={<VRVGuide />} />
          <Route path="/blog/what-size-ac-do-i-need" element={<SizeGuide />} />
          <Route path="/blog/hot-and-cold-ac" element={<HeatGuide />} />
          <Route path="/blog/vrv-system-for-home" element={<VrvHomeGuide />} />
          <Route path="/hvac-consultant" element={<Consultation />} />
          <Route path="/hvac-consultation" element={<OldConsultUrl />} />
          <Route path="/architects-interior-designers" element={<Architects />} />
          <Route path="/daikin-ac-price-list-delhi" element={<DaikinPrices />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/get-quote" element={<Checkout />} />
          <Route path="/order-confirmed" element={<OrderConfirmed />} />
          <Route path="/request-unit" element={<RequestUnit />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/admin/stock" element={<StockAdmin />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/delivery-policy" element={<DeliveryPolicy />} />
        </Routes>
        <CookieNotice />
        <Footer />
        <WhatsAppFloat />
        <PhoneFloat />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;